/**
 * Merge callbacks by returning a function that calls both functions. This is useful for components
 * that need to provide callback functionality, but want to allow additional functionality to be
 * provided
 * @example
 * const MyComponent = ({ myProp, ...elemProps }) => {
 *   return (
 *     <button onClick={mergeCallback(cb, elemProps.onClick)}>Click Me</button>
 *   )
 * }
 * @param elemProps Props passed into a component
 * @param componentProps Props the component provides
 */
export function mergeCallback(callback1, callback2) {
    if (callback2) {
        return ((...args) => {
            callback1.apply(null, args);
            callback2.apply(null, args);
        });
    }
    else {
        return callback1;
    }
}
